// Summary aggregates and selection eligibility, over the complete matching set rather than the visible page.

import { cellValue, isNumber } from '../format'

const aggregateOf = column =>
  column.capabilities ? column.capabilities.summary : column.summary || null

// 'sum' adds the column's numeric values; a function aggregate receives the complete matching set
export const summarize = (rows, columns) => {
  const totals = {}
  columns.forEach(column => {
    const aggregate = aggregateOf(column)
    if (typeof aggregate === 'function') totals[column.key] = aggregate(rows)
    else if (aggregate === 'sum')
      totals[column.key] = rows.reduce((sum, row) => {
        const value = cellValue(column, row)
        return isNumber(value) ? sum + value : sum
      }, 0)
  })
  return totals
}

// Matching rows that selection may use; every row is eligible when the instance declares no rule.
export const eligibleCount = (rows, selection) => {
  if (!selection) return 0
  if (typeof selection.isEligible !== 'function') return rows.length
  return rows.filter(row => selection.isEligible(row) !== false).length
}
